// extracted by mini-css-extract-plugin
export var highlightFade = "_2l-4";
export var highlighted = "_2l-3";
export var table = "_2l-1";
export var tableContainer = "_2l-0";
export var totalsRow = "_2l-2";